import Vue from 'vue';
import Vuex from 'vuex';

import mutations from './mutations';
import actions from './actions';
import user from './modules/user.js';
import real from './modules/real.js';
import address from './modules/address.js';
import card from './modules/card.js';
import addcard from './modules/addcard.js';
import share from './modules/share.js';

Vue.use(Vuex);

const state = {
  loginStatus: false,
  limit: 25
};
const store = new Vuex.Store({
  state,
  mutations,
  actions,
  modules: {
    user,
    real,
    address,
    card,
    addcard,
    share
  }
});
store.subscribe((action, state) => {
  console.warn(`更新key: > ${action.type}  val: > ${JSON.stringify(action.payload)}`);
});
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js